<template>
  <ModalDialog
    :show-dialog="isShow"
    title="ご契約内容に関するご案内"
    title-class="text-lg"
    close-text="あとで確認する"
    close-text-border-class="border"
    close-text-color-class="text-gray-92"
    close-text-bg-class="bg-white"
    ok-text="内容を確認しました"
    ok-text-color-class="text-white"
    ok-text-bg-class="bg-coral-main"
    @ok-action="handleOk()"
    @close-dialog="handleCancel()"
  >
    <div class="text-sm font-normal" style="line-height: 21px">
      <p>以降の操作についてご契約書記載の紹介課金が発生いたします。</p>
      <p>・お見積もりの提出</p>
      <p>・メッセージの送信</p>
    </div>
  </ModalDialog>
</template>
<script>
import ModalDialog from '@/components/modalDialog.vue';
export default {
  components: { ModalDialog },
  emits: ['ok', 'cancel'],
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const handleOk = () => {
      emit('ok');
    };
    const handleCancel = () => {
      emit('cancel');
    };
    return {
      handleOk,
      handleCancel,
    };
  },
};
</script>

<style lang="scss" scoped></style>
